import api from "./api";

export const transformTextWithAi = async ({
  action,
  text,
  targetLanguage
}) => {
  const { data } = await api.post("/ai/text-tools", {
    action,
    text,
    targetLanguage
  });

  return data;
};

export const suggestReplyWithAi = async ({
  text,
  targetLanguage = "Brazilian Portuguese (pt-BR)"
}) => {
  const { data } = await api.post("/ai/text-tools", {
    action: "suggest_reply",
    text,
    targetLanguage
  });

  return data;
};
